import { SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

export const CheckoutHeading = styled(SpaceBetween)`
  ${Typography} {
    color: ${tk('color_semantic_text')};
  }
`;

CheckoutHeading.displayName = 'CheckoutHeading';

export const CheckoutHeadingTitle = styled(Typography)`
  ${Typography.modVariant('heading-md')}
`;

export const CheckoutHeadingDescription = styled(Typography)`
  ${Typography.modVariant('body-md')}
`;
